// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/emergency-phraseology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/emergency-phraseology/emergency-phraseology.js';

mount([g0]);
